module.exports = __webpack_public_path__ + "assets/img/g2a.40ced3f2.png";